import { RequestConfig } from '~/common/services/requests';
import { ApplicationForm } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const getApplicationForm = async (
  constructGet: ConstructGet,
  uuid: string,
  definitionName: string,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<ApplicationForm> | undefined> =>
  constructGet(`${APPLICATION_BASE_PATH}/${uuid}/form`, {
    params,
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
    },
  });
